import { Icon } from '@eventbrite/eds-icon';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './Tiles.scss';

export const Tile = (props: {
    icon?: JSX.Element;
    name?: string | GenericLazyString;
}) => {
    const { icon, name } = props;

    return (
        <div className="tile">
            <aside className="tile--icon">
                <Icon type={icon} size="small" color="ui-orange" />
            </aside>
            <div className="tile--name eds-text-weight--heavy">{name}</div>
        </div>
    );
};
